import React, { createContext, useContext, useState } from 'react';
import { fr } from '../locales/fr';
import { en } from '../locales/en';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Récupère la langue sauvegardée ou utilise 'fr' par défaut
    return localStorage.getItem('language') || 'fr';
  });

  const translations = language === 'fr' ? fr : en;

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, translations, changeLanguage, t: translations }}>
      {children}
    </LanguageContext.Provider>
  );
};

